import { render, staticRenderFns } from "./PaymentDetailsView.vue?vue&type=template&id=3bd5d334&scoped=true&"
import script from "./PaymentDetailsView.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailsView.vue?vue&type=style&index=0&id=3bd5d334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5d334",
  null
  
)

export default component.exports